import { styled } from '@mui/material';

import { VrsCallDetails } from './VrsCallDetails';

import { CallDetailsAccordianMenu } from 'features/call/call-details/components';
import theme from 'features/theme/theme';

export const VrsCallDetailsContainer = () => {
  return (
    <CallDetailsAccordianMenu>
      <Container>
        <VrsCallDetails />
      </Container>
    </CallDetailsAccordianMenu>
  );
};

const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(14, 12, 12, 12)};
`;
